export default "__VITE_ASSET__C_DL$J46__"